import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'auth-forbidden',
  standalone: true,
  imports: [],
  templateUrl: './forbidden.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenComponent {}
